import { render, staticRenderFns } from "./RTapHowItWorks.vue?vue&type=template&id=0fa8fc68&"
import script from "./RTapHowItWorks.vue?vue&type=script&lang=js&"
export * from "./RTapHowItWorks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports